import { Field } from '@yes.technology/react-toolkit'
import type { FilterField } from '../types/fields'
import type { Operator } from '../types/operators'
import { FilterFieldType, type FieldType } from './fieldType'

export { FilterFieldType } from './fieldType'
export type { FieldType } from './fieldType'

export function formatFields(fields: Field[]): FilterField[] {
  return (
    (fields?.length > 0 &&
      fields.map((field) => {
        return {
          uuid: field.uuid,
          id: field.uuid,
          name: field.column_json,
          readOnly: field.read_only,
          type: field.type as FieldType,
          label: field.display_text.des,
          objectclassUuid: field.relation_objectclass_uuid
        }
      })) ||
    []
  )
}

type NormalizeOperatorProps = {
  originalOperator: Operator
  /** Toolkit `Field.type` or filter-state type string. */
  fieldType: string
}

export function normalizeOperator({
  originalOperator,
  fieldType
}: NormalizeOperatorProps): Operator {
  if (fieldType !== FilterFieldType.Relation) {
    return originalOperator
  }

  return ['ne', 'nin'].includes(originalOperator) ? 'nin' : 'in'
}
